import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";

export const Template = ({
    isZoomed = false,
    image = "",
    withInlinePagination = false,
}) => {
    const srcset = image || "./mock-assets/green-market-form/product-2.png";
    return html`
        <ux-iws-slider-slide-zoomable
            data-swiper-slide-index="1"
            ?is-zoomed=${ifDefined(isZoomed)}
        >
            <div class="block block-hero">
                <div class="block-image">
                    <picture>
                        <source
                            media="(max-width: 567px)"
                            class="ux-slider-lazy-img-waiting swiper-lazy-loaded"
                            srcset="${srcset}" />
                        <source
                            media="(max-width: 1024px)"
                            class="ux-slider-lazy-img-waiting swiper-lazy-loaded"
                            srcset="${srcset}" />
                        <source
                            class="ux-slider-lazy-img-waiting swiper-lazy-loaded"
                            srcset="${srcset}" />
                        <img
                            class="ux-slider-lazy-img-waiting swiper-lazy-loaded"
                            alt="17:8 standard - viewport test images /w Retina support"
                            src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 1920 902%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                            srcset="${srcset}"
                    /></picture>
                </div>
                <div class="block-zoom-image">
                    <picture
                        ><img
                            class="ux-slider-lazy-img-waiting swiper-lazy-loaded"
                            alt=""
                            src="${srcset}"
                    /></picture>
                </div>
                <div class="block-content">
                    <div class="ux-text-tiny ux-u-text-uppercase">
                        <strong>2D-Laserschneidmaschinen</strong>
                    </div>
                    <h2 class="ux-text-headline--giant">TruLaser 1030</h2>
                    <p class="text-normal">
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                        sed diam nonumy eirmod tempor.
                    </p>
                    <div class="block-button ux-u-text-align--center">
                        <a class="ux-button ux-button--green" href="#"
                            >Equipment</a
                        >
                    </div>
                    ${withInlinePagination
                        ? html`<div
                              class="ux-slider-inline-pagination-anchor"
                          ></div>`
                        : ""}
                </div>
                <div class="block-shadow"></div>
                <div class="btn-zoom-wrapper">
                    <a
                        class="btn-zoom"
                        href="#"
                        data-ux-slider-slide-zoom="zoom"
                    >
                        <ux-icon
                            rel="zoom-out"
                            name="chevron-inwards"
                            weight="bold"
                            aria-label="Zoom out"
                        ></ux-icon>
                        <ux-icon
                            rel="zoom-in"
                            name="chevron-outwards"
                            weight="bold"
                            aria-label="Zoom in"
                        ></ux-icon>
                    </a>
                </div>
            </div>
        </ux-iws-slider-slide-zoomable>
    `;
};
